import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import ChartPane from "../activation/kit/ChartPane";

// ------------------------------------------
//  Positive voice feedback
// ------------------------------------------
const encouragementWords = [
  "Amazing!",
//   "Bullish!",
//   "You're on fire!",
//   "Nice move!",
//   "Awesome!",
//   "Clean tap!",
//   "Perfect!",
//   "Love it!",
//   "Boom!",
//   "Leveling up!",
];

const speakEncouragement = () => {
  const msg =
    encouragementWords[Math.floor(Math.random() * encouragementWords.length)];
  const utter = new SpeechSynthesisUtterance(msg);
  utter.rate = 1.05;
  utter.pitch = 1.1;
  utter.volume = 1;
  window.speechSynthesis.speak(utter);
};

export default function ProbeAskChartLesson({ candles, onContinue }) {
  const [selectedInsight, setSelectedInsight] = useState(null);
  const [currentBubbleIndex, setCurrentBubbleIndex] = useState(0);
  const [showCelebration, setShowCelebration] = useState(false);
  const [showToro, setShowToro] = useState(false); // toro pop animation

  const bubbles = [
    {
      id: "bubble1",
      x: 70,
      y: 170,
      color: "#FF7C24",
      text: "Buyers stepped in strongly here — notice the long wick.",
    },
    {
      id: "bubble2",
      x: 260,
      y: 230,
      color: "#4CAF50",
      text: "Momentum accelerated with consecutive green candles.",
    },
    {
      id: "bubble3",
      x: 430,
      y: 150,
      color: "#4DA3FF",
      text: "Breakout region — price pushed above previous highs.",
    },
  ];

  const handleTap = () => {
    const bubble = bubbles[currentBubbleIndex];
    speakEncouragement();
    setSelectedInsight(bubble.text);

    // Go to next bubble or finish
    if (currentBubbleIndex < bubbles.length - 1) {
      setCurrentBubbleIndex(currentBubbleIndex + 1);
    } else {
      // LAST BUBBLE → trigger inline celebration + toro pop
      setTimeout(() => {
        setShowToro(true);
        setTimeout(() => {
          setShowToro(false);
          setShowCelebration(true);
          onContinue(); // ENABLE Continue in ActivationFlow
        }, 1300);
      }, 250);
    }
  };

  const activeBubble = bubbles[currentBubbleIndex];

  return (
    <div style={S.container}>
      <div style={S.card}>
        {/* Chart */}
        <div style={S.chartWrapper}>
          <ChartPane height={280} candles={candles} />

          {/* Single bubble */}
          {!showCelebration && activeBubble && (
            <div
              style={{
                position: "absolute",
                top: activeBubble.y,
                left: activeBubble.x,
              }}
            >
              {/* Pulse ring */}
              <motion.div
                style={{ ...S.pulseRing, background: activeBubble.color }}
                animate={{ scale: [1, 1.8, 1], opacity: [0.5, 0, 0.5] }}
                transition={{ duration: 1.8, repeat: Infinity }}
              />

              {/* Bubble */}
              <motion.div
                style={{ ...S.bubble, background: activeBubble.color }}
                animate={{ y: [0, -4, 0] }}
                transition={{ repeat: Infinity, duration: 1.2 }}
                whileTap={{ scale: 0.65, opacity: 0 }}
                onClick={handleTap}
              >
                💬 Tap here
              </motion.div>
            </div>
          )}
        </div>

        {/* Inline insight box (only before celebration) */}
        {!showCelebration && selectedInsight && (
          <motion.div
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            style={S.insightBox}
          >
            {selectedInsight}
          </motion.div>
        )}

        {/* Toro pop animation */}
        {/* {showToro && (
          <motion.div
            initial={{ scale: 0, rotate: -10 }}
            animate={{ scale: 1.2, rotate: 0 }}
            exit={{ scale: 0 }}
            transition={{ type: "spring", stiffness: 220, damping: 14 }}
            style={S.toroPop}
          >
            🐂
          </motion.div>
        )} */}

        {/* Celebration (Option A: inside insight box area) */}
        {showCelebration && (
          <motion.div
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            style={S.insightBox}
          >
            🐂 Great job! You discovered all AI insights 🎉
          </motion.div>
        )}
      </div>
    </div>
  );
}

// --------------------------------------------------------

const S = {
  container: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },

  card: {
    width: "min(960px, 96%)",
    background: "#0F141B",
    border: "1px solid #1E2630",
    borderRadius: 16,
    padding: 16,
  },

  chartWrapper: {
    position: "relative",
    width: "100%",
  },

  pulseRing: {
    position: "absolute",
    width: 52,
    height: 52,
    borderRadius: "50%",
    opacity: 0.4,
    filter: "blur(4px)",
    top: -4,
    left: -4,
  },

  bubble: {
    padding: "10px 14px",
    borderRadius: 12,
    cursor: "pointer",
    fontWeight: 700,
    color: "#232830",
    position: "relative",
    zIndex: 5,
    boxShadow: "0 4px 14px rgba(0,0,0,0.35)",
  },

  insightBox: {
    marginTop: 16,
    padding: 14,
    background: "rgba(255,255,255,.08)",
    borderRadius: 12,
    color: "#fff",
    fontSize: 16,
    textAlign: "center",
    border: "1px solid rgba(255,255,255,0.1)",
  },

  toroPop: {
    marginTop: 16,
    fontSize: 52,
    textAlign: "center",
    width: "100%",
  },
};